(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class FooterMenu extends DetailsDisclosure {
      constructor() {
        super();
        this.reset(false);
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        const isConfirmNewsletter = !isLargeScreen &&
          (window.location.hash === "#footer-signup_form" && this.querySelector('#footer-signup_form') !== null);

        this.disclosure.open = isLargeScreen || isConfirmNewsletter;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }
    }

    customElements.define('footer-menu', FooterMenu);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class NavMenu extends DetailsDisclosure {
      constructor() {
        super();
        if (this.matches('.js-mega-nav')) {
          this.reset(false);
          window.addEventListener('on:breakpoint-change', this.reset.bind(this));
        }
      }
      reset(resize = true) {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        this.disclosure.open = isLargeScreen;
        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }
      handleToggle(e) {
        if (!(this.matches('.js-mega-nav') && window.matchMedia(theme.mediaQueries.md).matches)) {
          super.handleToggle(e);
        }
      }
    }
    customElements.define('nav-menu', NavMenu);
  });

  // Improved scroll function with bottom detection
  document.addEventListener('DOMContentLoaded', () => {
    const header = document.querySelector('store-header');
    const menu = document.querySelector('main-menu');
    if (!header || !menu) return;
    
    let lastScroll = 0;
    
    // Device detection functions
    const isMobile = () => window.innerWidth < 768;
    const isTablet = () => window.innerWidth >= 768 && window.innerWidth <= 1024;
    const isDesktop = () => window.innerWidth > 1024;
    
    window.addEventListener('scroll', () => {
      const currentScroll = window.scrollY;
      const maxScroll = document.body.scrollHeight - window.innerHeight;
      const isNearTop = currentScroll < 100;
      const isNearBottom = maxScroll - currentScroll < 100;
      
      // Different behavior based on device type
      if (isMobile()) {
        // Original mobile functionality - unchanged
        if (maxScroll - currentScroll < 50) {
          // At bottom of page, show normal header
          header.classList.remove('header--compact');
          menu.classList.remove('is-hidden');
          lastScroll = currentScroll;
          return;
        }
        
        if (currentScroll > 100) {
          header.classList.add('header--compact');
          
          if (currentScroll > lastScroll) {
            menu.classList.add('is-hidden');
          } else {
            menu.classList.remove('is-hidden');
          }
        } else {
          header.classList.remove('header--compact');
          menu.classList.remove('is-hidden');
        }
      } 
      else if (isTablet()) {
        // Tablet-specific behavior - similar to desktop but more tolerant
        if (isNearTop || isNearBottom || Math.abs(currentScroll - lastScroll) < 30) {
          // Keep menu visible when near top/bottom or if scroll amount is small
          menu.classList.remove('is-hidden');
          
          if (isNearTop) {
            header.classList.remove('header--compact');
          } else {
            header.classList.add('header--compact');
          }
        } else if (currentScroll > lastScroll + 50) {
          // Hide menu when scrolling down significantly
          menu.classList.add('is-hidden');
          header.classList.add('header--compact');
        } else if (currentScroll < lastScroll - 30) {
          // Show menu when scrolling up significantly
          menu.classList.remove('is-hidden');
        }
      }
      else {
        // Desktop behavior
        if (isNearTop || isNearBottom) {
          menu.classList.remove('is-hidden');
          
          if (isNearTop) {
            header.classList.remove('header--compact');
          } else {
            header.classList.add('header--compact');
          }
        } else {
          // Not at top or bottom - hide menu only
          menu.classList.add('is-hidden');
          header.classList.add('header--compact');
        }
      }
      
      lastScroll = currentScroll;
    });
    
    // Update menu visibility on resize
    window.addEventListener('resize', () => {
      if (isMobile()) {
        // Reset to default state on mobile
        const currentScroll = window.scrollY;
        if (currentScroll < 100) {
          header.classList.remove('header--compact');
          menu.classList.remove('is-hidden');
        }
      } else if (isTablet()) {
        // For tablet, check if we need to adjust based on current scroll
        const currentScroll = window.scrollY;
        if (currentScroll < 100) {
          header.classList.remove('header--compact');
          menu.classList.remove('is-hidden');
        }
      } else {
        // Check scroll position on desktop
        const currentScroll = window.scrollY;
        const maxScroll = document.body.scrollHeight - window.innerHeight;
        const isNearTop = currentScroll < 100;
        const isNearBottom = maxScroll - currentScroll < 100;
        
        if (!isNearTop && !isNearBottom) {
          menu.classList.add('is-hidden');
        } else {
          menu.classList.remove('is-hidden');
        }
      }
    });
  });

  } catch(e) { console.error(e); }
})();
})();
